import React from 'react';
import { Redirect } from 'react-router';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import RoleService from '../../services/utility/role';
import Fees from './components/fees.component';
import FeesDetailsComponent from './components/fees.details.component';

const roleService = new RoleService();

export default function FeesRoutersComponent(props) {
  const { path } = useRouteMatch();

  const hasAccess = roleService.checkRouteAccess(props, 'PROVIDER');
  if (hasAccess) {
    return (
      <React.Fragment>
        <Switch>
          <Route exact path={path}>
            {' '}
            <Fees />{' '}
          </Route>
          <Route exact path="/fees" component={Fees} />
          <Route exact path="/fees/:id" component={FeesDetailsComponent} />
        </Switch>
      </React.Fragment>
    );
  }
  return (
    <Redirect
      to={{
        pathname: '/unauthorized',
        state: {
          from: props.location,
        },
      }}
    />
  );
}
